var render = function render(){var _vm=this,_c=_vm._self._c;return _c('graph-detail08-template',{attrs:{"board-ids":[244],"field-code":"facility-public","com-group-list":_vm.comGroupList,"graph1-title":"전체 (공중(다중)이용시설) 중대재해 발생 현황","graph2-title":"월별 (공중(다중)이용시설) 중대재해 발생 현황","graph3-title":"기간별 (공중(다중)이용시설) 중대재해 발생 현황","field-label":"공중(다중)이용시설","field-category-label":"구분"}})
}
var staticRenderFns = []

export { render, staticRenderFns }